import apiUrl from "../../../../../utils/settings";

export const getEmployeesUrl = () => {
  return apiUrl + `/staff`;
};

export const addEmployeeUrl = () => {
  return apiUrl + `/staff`;
};

export const getRolesAndPermissionUrl = (firmID) => {
  return apiUrl + `/staff/available-roles?firm_id=${firmID}`;
};

export const getOwnersUrl = (firmID) => {
  return apiUrl + `/staff/owner-list?firm_id=${firmID}`;
};

export const updateStaffUrl = () => {
  return apiUrl + `/staff`;
};

export const deleteEmployeeUrl = (staff_id, firm_id) => {
  return apiUrl + `/staff?staff_id=${staff_id}&firm_id=${firm_id}`;
};